import { PARAM_BACKGROUND_KEY, PARAM_HIDE_LOADING } from "../constants/url-params";

export const appendUrlParam = (apiPath, param) => {
    if (apiPath.includes('?')) {
        return apiPath + '&' + param;
    } else {
        return apiPath + '?' + param;
    }
};

export const appendBackgroundParam = (apiPath) => {
    return appendUrlParam(apiPath, PARAM_BACKGROUND_KEY + '=true');
};

export const appendHideLoadingParam = (apiPath) => {
    return appendUrlParam(apiPath, PARAM_HIDE_LOADING + '=true');
};



// WEBPACK FOOTER //
// ./src/utils/query-handling.js